import { MapTo } from '@adobe/aem-react-editable-components';
import IframeComponent, { IframeComponentEditConfig } from './IframeComponent';

export default MapTo('cob-corp-acquisition/components/creditonebank/iframe-component')(IframeComponent, IframeComponentEditConfig);